import React, { useState, useEffect, useContext } from 'react';
import { Paper, Typography, Button, IconButton } from '@material-ui/core';
import { I18nContext } from 'translations';
import { COUNTRY_CODE } from 'utils/constants';
import CloseIcon from '@material-ui/icons/Close';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import ModalTermsDetails from 'components/Modals/ModalTermsDetails';
import ModalLimitante from 'components/Modals/ModalLimitante';

const ModalTermsChanged = ({ companyId, hasComment, hasAccepted, onContinue }) => {
  const { translate, langCode } = useContext(I18nContext);
  const isColombia = COUNTRY_CODE[langCode][1] === 'CO';
  const [open, setOpen] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [limitanteOpen, setLimitanteOpen] = useState(false);

  useEffect(() => {
    if (!hasAccepted) {
      setOpen(true);
    }
  }, [hasAccepted]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleAccept = () => {
    setDetailsOpen(false);
    onContinue && onContinue();
  };

  if (!open || hasAccepted || !isColombia) return null;

  return (
    <>
      <Paper
        elevation={0}
        style={{
          border: '1px solid #F59E0B',
          backgroundColor: '#FFFDF0',
          borderRadius: '8px',
          padding: '12px 16px 16px',
          marginBottom: '16px',
          maxWidth: '440px',
          position: 'absolute',
          zIndex: 2
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
          <FiberManualRecordIcon style={{ fontSize: 8, color: '#F59E0B', marginRight: 6 }} />
          <Typography
            variant="caption"
            style={{ color: '#F59E0B', fontWeight: 600, flexGrow: 1, fontSize: '12px' }}
          >
            {translate('company.change.badge')}
          </Typography>
          <IconButton size="small" onClick={handleClose} style={{ padding: 2 }}>
            <CloseIcon style={{ fontSize: 14, color: '#888' }} />
          </IconButton>
        </div>

        <Typography variant="body2" style={{ marginBottom: '14px', lineHeight: 1.5, color: '#333' }}>
          <b>{translate('company.change.provider')}</b>, {translate('company.change.description')}
        </Typography>

        <div style={{ display: 'flex', gap: '10px' }}>
          <Button
            variant="outlined"
            size="small"
            onClick={() => setDetailsOpen(true)}
            style={{ borderRadius: '4px', textTransform: 'none', fontSize: '13px' }}
          >
            {translate('company.change.viewAndAccept')}
          </Button>
          {!hasComment && (
            <Button
              variant="outlined"
              size="small"
              onClick={() => setLimitanteOpen(true)}
              style={{ borderRadius: '4px', textTransform: 'none', fontSize: '13px' }}
            >
              {translate('company.change.limitante')}
            </Button>
          )}
        </div>
      </Paper>

      <ModalTermsDetails
        open={detailsOpen}
        companyId={companyId}
        hasComment={hasComment}
        onAccept={handleAccept}
        onLimitante={() => { setDetailsOpen(false); setLimitanteOpen(true); }}
        onClose={() => setDetailsOpen(false)}
      />

      <ModalLimitante
        open={limitanteOpen}
        companyId={companyId}
        onClose={() => setLimitanteOpen(false)}
      />
    </>
  );
};

export default ModalTermsChanged;
